export function dataURItoBlob(dataURI, { filename = 'filename' } = {}) {
  const byteString = atob(dataURI.split(',')[1]);

  const mimeString = dataURI
    .split(',')[0]
    .split(':')[1]
    .split(';')[0];

  const ab = new ArrayBuffer(byteString.length);

  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new File([ab], `${filename}.${mimeString.split('/')[1]}`, {
    type: mimeString,
  });
}



// WEBPACK FOOTER //
// ./src/utils/base64ToFile.js